module.exports = __webpack_public_path__ + "img/Canva.a8d8f0d0.svg";